import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/api";

const LINKS = [
  ["About", "about"],
  ["Services", "services"],
  ["Packages", "packages"],
  ["Apps", "apps"],
  ["Work", "work"],
  ["Maintenance", "maintenance"],
  ["Process", "process"],
  ["FAQ", "faq"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b border-white/10 bg-black/60 backdrop-blur-xl backdrop-saturate-150">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4" aria-label="Main">
        <Logo />
        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map(([label, id]) => (
            <a
              key={id}
              href={`#${id}`}
              data-testid={`nav-${id}-link`}
              onClick={go(id)}
              className="text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-[#00F0FF] focus:outline-none focus:ring-2 focus:ring-[#00F0FF] rounded"
            >
              {label}
            </a>
          ))}
          <button
            data-testid="nav-consultation-btn"
            onClick={() => scrollToId("contact")}
            className="group flex items-center gap-2 rounded-full bg-[#00F0FF] px-5 py-2.5 text-sm font-bold text-[#050811] transition-shadow duration-300 hover:shadow-[0_0_28px_rgba(0,240,255,0.55)]"
          >
            Free Consultation
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
        <button
          data-testid="nav-mobile-menu-btn"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen(!open)}
          className="lg:hidden rounded-lg p-2 text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#00F0FF]"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#050811]/95 backdrop-blur-xl px-6 py-5 space-y-4" data-testid="nav-mobile-menu">
          {LINKS.map(([label, id]) => (
            <a
              key={id}
              href={`#${id}`}
              data-testid={`nav-mobile-${id}-link`}
              onClick={go(id)}
              className="block text-base font-medium text-slate-200 hover:text-[#00F0FF]"
            >
              {label}
            </a>
          ))}
          <button
            data-testid="nav-mobile-consultation-btn"
            onClick={() => { setOpen(false); scrollToId("contact"); }}
            className="w-full rounded-full bg-[#00F0FF] px-5 py-3 text-sm font-bold text-[#050811]"
          >
            Free Consultation
          </button>
        </div>
      )}
    </header>
  );
}
